export default "__VITE_ASSET__0KNO07ww__"